export enum Bucket {
    retail = 'prod-ewa-retail-claims-doc',
     group = 'prod-ewa-claim-docs'
}